/* Tysk katalog for locale-payroll-runs-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'pay.salaryTypeSaved': 'Lohnart gespeichert.',
  'pay.salaryTypeSaveFailed': 'Lohnart konnte nicht gespeichert werden.',
  'pay.fixedLineSaved': 'Feste Lohnzeile gespeichert.',
  'pay.fixedLineSaveFailed': 'Feste Lohnzeile konnte nicht gespeichert werden.',
  'pay.fillNameAndAccountNumber': 'Trage Name und Kontonummer ein.',
  'pay.accountAdded': 'Konto hinzugefügt.',
  'pay.addAccountFailed': 'Konto konnte nicht hinzugefügt werden.',
  'pay.calculationCodeNotSupported': 'Dieser Berechnungscode für die Arbeitgeberabgabe wird noch nicht unterstützt. Wähle „Allgemeine Branchen“.',
  'pay.payrollSettingsSaved': 'Lohneinstellungen gespeichert.',
  'pay.payrollSettingsSavedWithRecalc': 'Lohneinstellungen gespeichert. {count} offene Lohnentwürfe wurden neu berechnet.',
  'pay.payrollSettingsSaveFailed': 'Lohneinstellungen konnten nicht gespeichert werden.',
  'pay.markedManualSubmission': 'Als manuelle Einreichung markiert.',
  'pay.ameldingSentToAltinn': 'A-melding an Altinn gesendet.',
  'pay.payslipsCreatedAndPosted': 'Lohnabrechnungen erstellt und Lohn gebucht. Die Lohnabrechnungen können später versendet werden.',
  'pay.payrollRunEditableAgain': 'Die Lohnauszahlung kann wieder bearbeitet werden.',
  'pay.accountingAnnulled': 'Die Buchung wurde annulliert.',
  'pay.payrollRunAnnulled': 'Lohnauszahlung annulliert.',
  'pay.payoutRegistered': 'Auszahlung erfasst.',
  'pay.confirmAnnulPayment': 'Diese Zahlung annullieren? Die Buchung wird storniert, indem die Zahlung nicht mehr berücksichtigt wird.',
  'pay.hideDeletedPayrollRuns': 'Gelöschte Lohnauszahlungen ausblenden',
  'pay.showDeletedPayrollRuns': 'Gelöschte Lohnauszahlungen anzeigen ({count})',
  'pay.removePermanently': 'Endgültig entfernen',
  'pay.removeDeletedPayrollRunPermanently': 'Gelöschte Lohnauszahlung endgültig entfernen',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Gelöschte Lohnauszahlung entfernen?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Dadurch wird der Entwurf für {period} endgültig entfernt. Nur Lohn, der nie genehmigt, gesendet oder gebucht wurde, kann hier entfernt werden.',
  'pay.editPaymentTitle': 'Zahlung bearbeiten',
  'pay.registerPaymentTitle': 'Zahlung erfassen',
  'pay.savingEllipsis': 'Wird gespeichert...',
  'pay.savePaymentAction': 'Zahlung speichern',
  'pay.editSalaryTypeTitle': 'Lohnart bearbeiten',
  'pay.newFixedLineTitle': 'Neue feste Lohnzeile',
  'pay.editFixedLineTitle': 'Feste Lohnzeile bearbeiten',
  'pay.operatingAccount': 'Geschäftskonto',
  'pay.newWithholdingAccountTitle': 'Neues Steuerabzugskonto',
  'pay.newPayrollAccountTitle': 'Neues Lohnkonto',
  'pay.addAccountAction': 'Konto hinzufügen',
  'pay.totalPay': 'Gesamtlohn',
  'pay.taxDeduction': 'Steuerabzug',
  'pay.voucher': 'Beleg',
  'pay.basis': 'Grundlage',
  'pay.payrollRuns': 'Lohnläufe',
  'pay.agaOfHolidayPayFull': 'Arbeitgeberabgabe auf Urlaubsgeld',
  'pay.deadline': 'Frist',
  'pay.paidAmount': 'Bezahlt',
  'pay.remaining': 'Verbleibend',
  'pay.provider': 'Anbieter',
  'pay.orgNumber': 'Org.-Nr.',
  'pay.earnedAtStandardRate': 'Erworben (10,2 %)',
  'pay.ameldingRegistered': 'A-melding erfasst',
  'pay.noSubmissions': 'Keine Einreichungen',
  'pay.posted': 'Gebucht',
  'pay.notPosted': 'Nicht gebucht',
  'pay.payslipsNotGenerated': 'Lohnabrechnungen wurden nicht erstellt.',
  'pay.employmentSetOnEmployeePage': 'Das Arbeitsverhältnis wird auf der Mitarbeiterseite festgelegt',
  'pay.rulesFromSalaryType': 'Regeln aus der Lohnart',
  'pay.useStandardRules': 'Standardregeln verwenden',
  'pay.advancedSettings': 'Erweiterte Einstellungen',
  'pay.overrideCanChangeCalculation': 'Eine Übersteuerung kann Steuer, Arbeitgeberabgabe, Urlaubsgeld, OTP und Buchung für diese Zeile ändern.',
  'pay.removeFromFixedLines': 'Aus den festen Lohnzeilen entfernen',
  'pay.makeThisAFixedLine': 'Zu einer festen Lohnzeile machen',
  'pay.withholdingExceedsCashPayWarning': 'Der Lohnsteuerabzug ist höher als Barlohn und Erstattungen. Füge Barlohn hinzu oder reduziere den Abzug, bevor der Lohnlauf genehmigt werden kann.',
  'pay.attachDocumentationHint': 'Füge Unterlagen zur Lohnauszahlung bei, zum Beispiel Stundenzettel oder manuelle Reisekostenabrechnungen.',
  'pay.upload': 'Hochladen',
  'pay.step1AltinnHelp': 'Wenn alle Zeilen enthalten sind, ist der nächste Schritt die Meldung der Lohnauszahlung. Die Altinn-Integration wird später angebunden, daher kann die Meldung vorerst als manuelle Einreichung markiert werden.',
  'pay.step3PayslipsHelp': 'Sobald die Lohnauszahlung gemeldet und genehmigt ist, werden Lohnabrechnungen erstellt und der Lohn wird gebucht.',
  'pay.step4PaymentHelp': 'Erfasse und buche die Auszahlung des Lohns an die Mitarbeiter und des Lohnsteuerabzugs an Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Die Lohnauszahlung wird abgeschlossen, sobald die Zahlung erfasst ist.',
  'pay.productionSupportedProfile': 'Für die Produktion unterstütztes Profil: norwegische Lohnabrechnung, Monatszeitraum, Allgemeine Branchen und Prozent-Steuerkarten. Tabellen-Steuerkarten, besondere Codes für die Arbeitgeberabgabe und elektronische Einreichung ohne Quittung sind gesperrt.',
  'pay.searchMunicipalityOrNumber': 'Gemeinde oder Nummer suchen',
  'pay.notSupportedYet': 'noch nicht unterstützt',
  'pay.chooseGeneralIndustriesWarning': 'Wähle „Allgemeine Branchen“, bevor die Einstellungen gespeichert werden können. Der zuvor gewählte Berechnungscode ist nicht implementiert.',
  'pay.searchProvider': 'Anbieter suchen',
  'pay.month.may': 'Mai',
  'pay.payTypeNotFixedLine': 'Diese Lohnart kann nicht als feste Lohnzeile verwendet werden.',
  'pay.calculationCodeUnsupportedShort': 'Dieser Berechnungscode für die Arbeitgeberabgabe wird noch nicht unterstützt.',
  'pay.overtimePay': 'Überstunden',
  'pay.mileageAllowance': 'Kilometerpauschale',
  'pay.driveFallback': 'Fahrt',
  'pay.taxableMileagePortion': 'Steuerpflichtiger Anteil',
  'pay.expenseCategoryOther': 'Sonstiges',
  'pay.overnightStayFallback': 'Übernachtung',
  'pay.hotelFallback': 'Hotel',
  'pay.mileagePayoutFallback': 'Fahrtkostenerstattung',
  'pay.ownCar': 'Eigenes Auto',
  'pay.travelPurposeFallback': 'Reise',
  'pay.taxTermWithholdingLabel': 'Lohnsteuerabzug {{date}}',
  'pay.taxTermAgaLabel': 'Zeitraum {{term}}',
  'pay.payrollRunNotEditableForNewLines': 'Einem genehmigten Lohnlauf können keine neuen Lohnzeilen hinzugefügt werden.',
  'pay.payTypeNotManualEntry': 'Diese Lohnart kann nicht manuell hinzugefügt werden.',
  'pay.receiptInboxFallbackName': 'Beleg aus dem Posteingang',
  'pay.approvedButPayslipsFailed': 'Der Lohn ist gebucht, aber die Lohnabrechnungen wurden nicht versendet: {{error}}',
  'pay.recon.runLabelPeriod': 'Lohn {{period}}',
  'pay.recon.runLabelRun': 'Lauf {{date}}',
  'pay.recon.notPaid': 'Nicht ausgezahlt',
  'pay.recon.paidAfterPeriod': 'Nach dem Periodendatum ausgezahlt',
  'pay.recon.flag.negativ_netto': 'Negativer Nettolohn',
  'pay.recon.flag.mangler_skattekort': 'Steuerkarte fehlt',
  'pay.recon.flag.sluttet_ansatt': 'Auszahlung an ausgeschiedenen Mitarbeiter',
  'pay.recon.flag.naturalytelse': 'Sachbezug zur Prüfung',
  'pay.recon.flag.uvanlig_endring': 'Ungewöhnliche Lohnänderung',
  'pay.recon.flag.mangler_amelding': 'Fehlt in der A-melding',
  'pay.recon.flag.mulig_duplikat': 'Mögliche Doppelauszahlung',
  'pay.recon.flag.ikke_utbetalt': 'Nicht ausgezahlt',
  'pay.recon.unknownEmployee': 'Unbekannter Mitarbeiter',
  'pay.recon.employmentTypeFixed': 'Unbefristet',
  'pay.recon.reported': 'Gemeldet',
  'pay.recon.notReported': 'Nicht gemeldet',
  'pay.recon.afterPeriodDate': 'Nach dem Periodendatum',
  'pay.recon.role.forskuddstrekk': 'Lohnsteuerabzug im Zeitraum',
  'pay.recon.role.aga': 'Berechnete Arbeitgeberabgabe auf Lohn',
  'pay.recon.role.aga_feriepenger': 'Berechnete Arbeitgeberabgabe auf Urlaubsgeld',
  'pay.recon.role.feriepenger': 'Urlaubsgeldverpflichtung laut Lohnsystem',
  'pay.recon.role.skyldig_lonn': 'Nettolohn und Abzüge aus dem Lohnsystem',
  'pay.recon.role.pensjon': 'Rentenbeitrag aus dem Lohnsystem',
  'pay.recon.row.brutto': 'Bruttolohn',
  'pay.recon.row.naturalytelser': 'Steuerpflichtige Sachbezüge',
  'pay.recon.row.trekkpliktige': 'Abzugspflichtige Leistungen',
  'pay.recon.row.godtgjorelser': 'Aufwandsentschädigungen',
  'pay.recon.row.aga_grunnlag': 'Bemessungsgrundlage der Arbeitgeberabgabe',
  'pay.recon.row.aga': 'Berechnete Arbeitgeberabgabe',
  'pay.recon.row.netto': 'Nettolohn',
  'pay.recon.row.andre_trekk': 'Andere Abzüge',
  'pay.recon.row.feriepenger': 'Erworbenes Urlaubsgeld',
  'pay.recon.row.pensjon': 'Rentenbeitrag',
  'pay.recon.source.payrollSystem': 'Lohnsystem',
  'pay.recon.source.bankPayouts': 'Bankauszahlungen',
  'pay.recon.source.pensionBasis': 'Rentengrundlage',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} gebuchter Lauf im Zeitraum',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} gebuchte Läufe im Zeitraum',
  'pay.recon.source.payrollSystemDetailEmpty': 'Keine gebuchten Lohnläufe im Zeitraum',
  'pay.recon.source.ledgerDetail': '{{count}} Buchungen auf den Lohnkonten',
  'pay.recon.source.ledgerDetailEmpty': 'Keine Buchungen auf den Konten, die dem Lohnbereich zugeordnet sind',
  'pay.recon.source.ameldingDetailNone': 'Keine Läufe zu melden',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} von {{total}} Läufen sind als gemeldet erfasst',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} von {{total}} Läufen sind nicht als gemeldet erfasst',
  'pay.recon.source.bankDetailNone': 'Keine Läufe zu bezahlen',
  'pay.recon.source.bankDetailPaid': '{{paid}} von {{total}} Läufen sind als ausgezahlt erfasst',
  'pay.recon.source.pensionDetailPresent': 'Vom Lohnsystem berechneter Rentenbeitrag',
  'pay.recon.source.pensionDetailNone': 'Kein Rentenbeitrag im Zeitraum',
  'pay.recon.check.bokfort': 'Alle Lohnläufe sind gebucht',
  'pay.recon.check.hovedbok': 'Das Lohnsystem stimmt mit dem Hauptbuch überein',
  'pay.recon.check.kontrollkontoer': 'Die Kontrollkonten stimmen mit der Grundlage überein',
  'pay.recon.check.bank': 'Der Nettolohn wurde ausgezahlt',
  'pay.recon.check.amelding': 'Die A-melding ist als übermittelt erfasst',
  'pay.recon.check.skattekort': 'Alle Mitarbeitenden haben eine gültige Steuerkarte',
  'pay.recon.check.negativ': 'Keine negativen Nettobeträge',
  'pay.recon.check.duplikat': 'Mögliche Doppelzahlungen sind identifiziert',
  'pay.recon.check.uvanlig': 'Ungewöhnliche Lohnänderungen sind identifiziert',
  'pay.recon.check.sluttet': 'Zahlungen an ausgeschiedene Mitarbeitende sind identifiziert',
  'pay.recon.check.naturalytelse': 'Sachbezüge sind analysiert',
  'pay.recon.check.feriepenger': 'Die Urlaubsgeldverbindlichkeit ist abgestimmt',
  'pay.recon.check.termin': 'Lohnsteuerabzug und Arbeitgeberabgabe sind beglichen',
  'pay.creatingRun': 'Wird erstellt…',
  'pay.pensionPremiumAmount': 'Tatsächliche Pensionsprämie',
  'pay.pensionBankAmount': 'Von der Bank bezahlt',
  'pay.pensionFeeAmount': 'Gesonderte Gebühr (brutto)',
  'pay.pensionFeeVat': 'MwSt. auf Gebühr',
  'pay.pensionFeeAccount': 'Aufwandskonto für Gebühr',
  'pay.pensionOverpaymentNotice': 'Die Differenz wird als Vorauszahlung an den Pensionsanbieter auf Konto 1570 gebucht.',
  'pay.createLaterCorrection': 'Korrektur in späterer Periode erstellen',
  'pay.createCorrection': 'Korrektur erstellen',
  'pay.laterCorrectionHelp': 'Der ursprüngliche Lauf bleibt erhalten. Wenn die Korrektur genehmigt wird, wird nur die Differenz in der neuen Periode gebucht.',
  'pay.correctionCreated': 'Der Korrekturlauf wurde als Entwurf erstellt.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Eigene',
  'pay.statusInactive': 'Inaktiv',
  'pay.ruleTag.aga': 'AGA',
  'pay.ruleTag.tax': 'Steuer',
  'pay.ruleTag.holiday': 'Urlaubsg.',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Arbeitgeberabgabepflichtig',
  'pay.ruleTitle.tax': 'Lohnsteuerabzugspflichtig',
  'pay.ruleTitle.holiday': 'Urlaubsgeldgrundlage',
  'pay.ruleTitle.pension': 'Pensionsgrundlage',
  'pay.stdType.monthly-salary': 'Festgehalt',
  'pay.stdType.hourly': 'Stundenlohn - keine Überstunden',
  'pay.stdType.overtime-hourly': 'Stundenlohn - Überstunden',
  'pay.stdType.commission-pay': 'Honorar, Akkord-, Prozent- oder Provisionslohn',
  'pay.stdType.bonus-holiday-pay': 'Bonus, urlaubsgeldberechtigt',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, nicht urlaubsgeldberechtigt',
  'pay.stdType.board-fee': 'Vorstandsvergütung',
  'pay.stdType.company-car': 'Dienstwagen',
  'pay.stdType.other-benefits': 'Sonstige Vorteile',
  'pay.stdType.taxable-insurance': 'Versicherungen, steuerpflichtiger Anteil',
  'pay.stdType.car-km-allowance': 'Kilometergeld',
  'pay.stdType.car-km-allowance-taxable': 'Kilometergeld, abzugspflichtiger Anteil',
  'pay.stdType.holiday-pay-current': 'Im laufenden Jahr erworbenes Urlaubsgeld',
  'pay.stdType.holiday-pay-previous': 'In Vorjahren erworbenes Urlaubsgeld',
  'pay.stdType.pension-premium': 'Pensionsprämie OTP',
  'pay.stdType.canteen-deduction': 'Kantinenabzug',
  'pay.stdType.holiday-deduction': 'Lohnabzug für Urlaub',
  'pay.stdType.extra-tax-deduction': 'Zusätzlicher Steuerabzug',
  'pay.stdType.employee-expense-settlement': 'Reisekostenerstattung',
  'pay.stdType.overnight-diet-hotel': 'Verpflegungspauschale bei Übernachtung',
});
